import {changeSet as genericChangeSet} from '@peachy/flash-repo-pure'
import {PeachyRepoRoot} from '@peachy/repo-domain'

export const changeSet = genericChangeSet<PeachyRepoRoot>